'use client';

import { MessageCircle } from 'lucide-react';
import { useSession } from 'next-auth/react';
import Link from 'next/link';

import { Button } from '@/components/ui/button';

export function MessageUserButton({ userId }: { userId: number | string }) {
  const { data: session, status } = useSession();
  const targetUserId = Number(userId);

  if (
    status !== 'authenticated' ||
    !session?.accessToken ||
    !Number.isSafeInteger(targetUserId) ||
    session.user.id === targetUserId
  ) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="outline"
      className="whitespace-nowrap max-md:h-8 max-md:px-3 max-md:text-xs"
      asChild
    >
      <Link href={`/communications?tab=messages&user=${targetUserId}`}>
        <MessageCircle className="mr-1.5 h-4 w-4" />
        <span className="hidden md:inline">Написать сообщение</span>
        <span className="md:hidden">Написать</span>
      </Link>
    </Button>
  );
}
